import script from "./ourLab.vue?vue&type=script&setup=true&lang=js"
export * from "./ourLab.vue?vue&type=script&setup=true&lang=js"

import "./ourLab.vue?vue&type=style&index=0&id=01563976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01563976"]])

export default __exports__